var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"8"}},[_vm._v(" "+_vm._s(_vm.value.comment)+" ")]),_c('v-col',{attrs:{"cols":"2"}},[_vm._v(" "+_vm._s(_vm.date)+" ")]),_c('v-col',{attrs:{"cols":"2"}},[_vm._v(" "+_vm._s(_vm.username)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }